import apiFetch from '../apiFetch'

export default function (token) {    
  return apiFetch({endPoint: `FichaVerraco/sincronizarIndexPIC`, method: 'POST', token: token})
}
